module.exports = __webpack_public_path__ + "img/ic_instagram_red.dce6ab1c.svg";